import { TweenMax, Linear, SteppedEase } from 'gsap'

class Animations {
  constructor () {
    this.activeAnimations = []
  }

  disable () {
    for (const anim of this.activeAnimations) {
      anim.kill()
    }
    this.activeAnimations = []
  }

  spinTurbine () {
    const turbine = document.querySelectorAll('.anim--turbine')
    const anim = TweenMax.fromTo(turbine, 7, {
      rotation: 0
    }, {
      rotation: 360,
      ease: Linear.easeNone,
      repeat: -1
    })
    this.activeAnimations.push(anim)
  }

  moveClockHand () {
    const hand = document.querySelector('.clock__hand')
    const steppedEase = new SteppedEase(60)
    const clock = TweenMax.to(hand, 60, {
      rotation: '360_cw',
      ease: steppedEase,
      repeat: -1
    }, 0)
    this.activeAnimations.push(clock)
  }
}

export { Animations }



// WEBPACK FOOTER //
// ./src/classes/Animations.js